export const THIS_FIELD_IS_REQUIRED = 'This field is required.';

export const FILE_MISSING = 'File is required. Please upload one.';
export const INVALID_DATA = 'This census file cannot be downloaded due to invalid data or incorrect format.';
export const OLD_FILE = 'This census file is unavailable for download as it is older than 30 days.';

export default THIS_FIELD_IS_REQUIRED;

export const DUPLICATED_RECORD = 'DUPLICATED_RECORD';

export const ERROR_CODE = {
  DUPLICATED_RECORD: 'DUPLICATED_RECORD',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  INVALID_CREDENTIAL: 'INVALID_CREDENTIAL',
  INVALID_ENROLLMENT_TOTAL: 'INVALID_ENROLLMENT_TOTAL',
};
